<template>
    <div>
        <div class="user_top_info_holder">
            <div class="profile_holder">
                <div class="profile_image_holder">
                    <profile-image
                      :platform_module_id="platform_module_id"
                      :image="clientDetails.basic_details.picture"
                      @changingImage="ImageChanged"
                    />
                </div>
                <div class="profile_details mt-5 px-4">
                    <h4>{{clientDetails.basic_details.first_name}} {{clientDetails.basic_details.last_name}}</h4>
                    <p>{{clientDetails.basic_details.user_type}}</p>
                </div>
            </div>
            <div class="cover_dp_holder">
                <CoverImage :clientDetails="clientDetails" @changingImage="ImageChanged" />
            </div>
        </div>
        <div class="user_profile_tabs_holder">
            <vs-tabs>
                <vs-tab label="Account">
                    <div>
                        <Account :clientDetails="clientDetails" :new_activity="new_activity" />
                    </div>
                </vs-tab>
                <vs-tab label="Profile">
                    <div>
                        <Profile :clientDetails="clientDetails" @setAfterUpdate="userUpdated" />
                    </div>
                </vs-tab>
                <vs-tab label="Users" v-if="clientDetails.basic_details.user_type=='Parent'">
                    <div>
                      <Users :users = "users" :parentDetails="clientDetails.basic_details" @userUpdated="userUpdated" />
                    </div>
                </vs-tab>
                <vs-tab label="Courses">
                    <div>
                        <Courses />
                    </div>
                </vs-tab>
                <vs-tab label="Teachers">
                    <div>
                        <Teachers />
                    </div>
                </vs-tab>
                <vs-tab label="Billings">
                    <div>
                        <Payments />
                    </div>
                </vs-tab>
                <vs-tab label="Files">
                    <div>
                        <UserFiles
                        :client_id="client_id"
                        :clientDetails="clientDetails"
                        :module_id="4" />
                    </div>
                </vs-tab>
            </vs-tabs>
        </div>
    </div>
</template>

<script>
import { ClientDetails, updateClient } from '@/api/client'
import { fetchCustomFields } from '@/api/customfield'
import { GeneralMixins } from '@/mixins/generalMixins/GeneralMixins.js'
import { getActivityList } from '@/api/activityLog'

import profileImage from '@/views/pages/v1/StudentProfile/userPicture.vue'
import CoverImage from '@/views/pages/v1/StudentProfile/userCoverPicture.vue'
import Account from './components/account/index.vue'
import Profile from './components/profile/index.vue'
import Users from './components/users/index.vue'
import Courses from './components/courses/index.vue'
import Teachers from './components/teachers/index.vue'
import Payments from './components/payments/index.vue'
import UserFiles from './components/userfiles/index.vue'

export default {
  data () {
    return {
      platform_module_id: 4,
      new_activity:null,
      client_id:null,
      clientDetails:null,
      users:[],
      custom_fields:[],
      dynamicfields:[]
    }
  },
  mixins:[GeneralMixins],
  mounted () {
    this.client_id = parseInt(this.$route.params.client_id)

    this.fetchclientsAccountDetails(this.client_id)
  },
  created () {

    this.fetchPLatformTimeZone()
  },
  components: {
    Account,
    Profile,
    Users,
    Courses,
    Teachers,
    Payments,
    UserFiles,
    profileImage,
    CoverImage
  },
  methods: {
    async userUpdated () {
      this.fetchclientsAccountDetails(this.client_id)
    },
    async ImageChanged (imageUrl, type) {
      try {
        const reqpayload = {
          updateField: {
            picture: type === 'Profile' ? imageUrl : this.clientDetails.basic_details.picture,
            cover_picture: type === 'CoverImage' ? imageUrl : this.clientDetails.basic_details.cover_picture,
            first_name: this.clientDetails.basic_details.first_name,
            middle_name: this.clientDetails.basic_details.middle_name,
            last_name: this.clientDetails.basic_details.last_name,
            email: this.clientDetails.basic_details.email,
            mobile: this.clientDetails.basic_details.mobile,
            address: this.clientDetails.basic_details.address,
            bio: this.clientDetails.bio,
            social_media: this.clientDetails.social_media
          }
        }
        const object1 = {
          dynamic_fields: {}
        }

        object1.dynamic_fields = this.dynamicform
        const payload = Object.assign({}, reqpayload, object1)

        const customer_id = localStorage.getItem('customer_id')

        const { data } = await updateClient(
          this.$route.params.client_id,
          payload,
          customer_id
        )
        this.clientDetails = data.data.clientUser

        this.getLastActivity()

        this.$vs.notify({
          title: 'Updated',
          text: 'Student updated successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      } catch (e) {
        this.$vs.notify({
          title: 'Error',
          text: e.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
      //
    },
    async getLastActivity () {
      const payload = {
        customer_id: localStorage.getItem('customer_id'),
        entity_id: this.$route.params.client_id,
        platform_module_id: 4
      }

      try {
        const response = await getActivityList(payload)
        this.new_activity = response.data.data.activity[0]
      } catch (e) {
        console.log(e)
      }
    },
    async fetchclientsAccountDetails (teacher_id) {
      try {
        const { data } = await ClientDetails(
          teacher_id,
          this.$store.getters.customerId
        )
        this.clientDetails = data.data.clientUser
        this.users = this.clientDetails.children
        //
        const child = this.clientDetails.basic_details
        child.client_user_address = this.clientDetails.basic_details.address
        child.client_user_address.client_users_id =
          this.clientDetails.basic_details.client_users_id
        //this.fetchTag(this.platform_module_id, this.clientDetails.tags)
        const __temp = {
          address: this.clientDetails.basic_details.address,
          child
        }
        this.users.unshift(__temp)
      } catch (e) {
        //
      } finally {
        this.fetchCustomField()
      }
    },
    async fetchCustomField () {
      try {
        const customerId = this.$store.getters.customerId
        const { data } = await fetchCustomFields('Client', customerId)

        this.custom_fields = data.data.custom_fields

        for (let i = 0; i < this.custom_fields.length; i++) {
          if (
            this.custom_fields[i].inputtype === 'checkbox' ||
            this.custom_fields[i].inputtype === 'multiselect'
          ) {

            let temp = []
            if (this.clientDetails[this.custom_fields[i].field]) {
              temp = this.clientDetails[this.custom_fields[i].field]
            }
            this.$set(this.dynamicform, this.custom_fields[i].field, temp)

          } else {
            this.dynamicform[this.custom_fields[i].field] =
              this.clientDetails[this.custom_fields[i].field]
          }
        }

        const dynamicfieldsarr = data.data.custom_fields.map((item) => {
          const container = {}
          container['name'] = item.label
          container['field'] = item.field
          container['is_collection'] = item.is_collection
          container['inputtype'] = item.inputtype

          return container
        })

        //
        this.dynamicfields = dynamicfieldsarr

        //
      } catch (e) {
        //
      }
    }
  }
}
</script>
